// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".related-article-image[data-v-3faf41ea]{width:calc(66.66667vw - 28px);padding-top:100%}.top-contents-image[data-v-3faf41ea]{width:100%;padding-top:75%}@media (min-width: 768px){.aspect-thumbnail[data-v-3faf41ea]{padding-top:68.13187%}.related-article-image[data-v-3faf41ea]{width:100%;height:auto}.top-contents-image[data-v-3faf41ea]{padding-top:75%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
